<template>
  <div id="loader" class="loader-overlay">
    <div class="loader-container">
      <div class="loader-card">
        <!-- Modern pulse loader -->
        <div class="loader-spinner">
          <div class="spinner-ring"></div>
          <div class="spinner-ring spinner-ring-2"></div>
          <div class="spinner-dot"></div>
        </div>
        <p class="loader-text">Loading...</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Loader",
  };
</script>

<style lang="scss" scoped>
  .loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-card {
    background: white;
    border-radius: 16px;
    padding: 32px 48px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.15), 
                0 8px 16px rgba(15, 23, 42, 0.1);
    animation: cardFadeIn 0.3s ease-out;
  }

  .loader-spinner {
    position: relative;
    width: 56px;
    height: 56px;
  }

  .spinner-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: #4D84FF;
    animation: spin 1s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }

  .spinner-ring-2 {
    width: 70%;
    height: 70%;
    top: 15%;
    left: 15%;
    border-top-color: transparent;
    border-right-color: #4D84FF;
    opacity: 0.6;
    animation: spinReverse 0.8s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }

  .spinner-dot {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    margin: -5px 0 0 -5px;
    background: linear-gradient(135deg, #4D84FF 0%, #3B6FE8 100%);
    border-radius: 50%;
    animation: pulse 1.2s ease-in-out infinite;
  }

  .loader-text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #64748B;
    margin: 0;
    letter-spacing: 0.3px;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes spinReverse {
    0% { transform: rotate(360deg); }
    100% { transform: rotate(0deg); }
  }

  @keyframes pulse {
    0%, 100% { 
      transform: scale(1);
      opacity: 1;
    }
    50% { 
      transform: scale(1.3);
      opacity: 0.7;
    }
  }

  @keyframes cardFadeIn {
    from {
      opacity: 0;
      transform: scale(0.95) translateY(-10px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }
</style>
